export default function PrefacturationConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('prefacturation');
}

PrefacturationConfiguration.$inject = ['$translatePartialLoaderProvider'];
